import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const servicesData = [
  {
    id: 1,
    category: 'IT Services',
    icon: '💻',
    color: '#6366f1',
    services: ['Web Development', 'Custom Web Apps', 'Process Automation', 'Cloud Migration'],
    description: 'Cutting-edge technology solutions for modern businesses'
  },
  {
    id: 2,
    category: 'Design/Engineering',
    icon: '✏️',
    color: '#8b5cf6',
    services: ['CAD Designing', '3D Modeling', 'Technical Drawings', 'Product Design'],
    description: 'Professional design services for engineering excellence'
  },
  {
    id: 3,
    category: 'Sales & Marketing',
    icon: '📊',
    color: '#ec4899',
    services: ['Lead Management', 'Digital Marketing', 'CRM Solutions', 'Sales Analytics'],
    description: 'Drive growth with data-driven marketing strategies'
  },
  {
    id: 4,
    category: 'Data Engineering',
    icon: '📈',
    color: '#10b981',
    services: ['Business Intelligence', 'Data Analytics', 'Data Pipeline Solutions', 'ETL Processing'],
    description: 'Transform data into actionable business insights'
  },
  {
    id: 5,
    category: 'AI Solutions',
    icon: '🤖',
    color: '#f59e0b',
    services: ['Custom AI Applications', 'Fine Tuning of LLMs', 'ML Model Development', 'AI Integration'],
    description: 'Harness the power of artificial intelligence'
  }
];

const Services = () => {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleLearnMore = (serviceId) => {
    if (serviceId === 1) {
      navigate('/services/it');
    } else if (serviceId === 2) {
      navigate('/services/design-engineering');
    } else if (serviceId === 3) {
      navigate('/services/sales-marketing');
    } else if (serviceId === 4) {
      navigate('/services/data-engineering');
    } else if (serviceId === 5) {
      navigate('/services/ai-solutions');
    }
  };

  return (
    <section className="services" id="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Comprehensive technology solutions designed to accelerate your digital transformation journey
        </p>
        
        <div className="services-grid">
          {servicesData.map((service) => (
            <div 
              className={`service-card ${hoveredCard === service.id ? 'hovered' : ''}`}
              key={service.id}
              onMouseEnter={() => setHoveredCard(service.id)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{'--card-color': service.color}}
            >
              <div className="service-icon-wrapper">
                <div className="service-icon">{service.icon}</div>
                <div className="icon-bg"></div>
              </div>
              
              <h3 className="service-title">{service.category}</h3>
              <p className="service-description">{service.description}</p>
              
              <ul className="service-list">
                {service.services.map((item, idx) => (
                  <li key={idx}>
                    <span className="checkmark">✓</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              
              <div className="service-hover-overlay">
                <button 
                  className="learn-more-btn"
                  onClick={() => handleLearnMore(service.id)}
                >
                  Learn More <span className="arrow">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
